var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRatingReview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 16.875,
    viewBox: "0 0 22.5 16.875",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5924",
    "data-name": "Group 5924",
    transform: "translate(0 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67748",
    "data-name": "Path 67748",
    d: "M0,7.75v5.625H6.563a4.693,4.693,0,0,1-4.688,4.688v2.812a7.508,7.508,0,0,0,7.5-7.5V4H3.75A3.75,3.75,0,0,0,0,7.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67749",
    "data-name": "Path 67749",
    d: "M17.75,4A3.75,3.75,0,0,0,14,7.75v5.625h6.563a4.693,4.693,0,0,1-4.687,4.688v2.812a7.508,7.508,0,0,0,7.5-7.5V4Z",
    transform: "translate(-0.875)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingReview);
export default __webpack_public_path__ + "static/media/rating_&_review.edecae6d864eac4c987d4882ecf8a1c7.svg";
export { ForwardRef as ReactComponent };